export default __webpack_public_path__ + "static/media/KZ.T.19.2276.75c8d116.svg";